export default __webpack_public_path__ + "static/media/tower-left.ad9a2734.svg";